import { gamesImagesData } from "../../utils/data/homePage.data";
import {
  EXCHANGE_EVENT_TYPES,
  fetchInplayEvent,
  fetchNotifications,
  getInplayEvents,
  LOGIN_ROUTE,
  RootState,
  setCompetition,
  setEventType,
  setIsLoginModalOpen,
  useAppDispatch,
  useAppSelector,
  getSectionGameImage,
  getSectionGameKey,
  getSectionGameLabel,
  getSectionGameNavigationPath,
  isProviderCategorySectionEntry,
  isSectionLottieFile,
  SectionGame,
  useHomeSectionGames,
  HomeSectionGamesProvider,
  CasinoTagsEnum,
  setAlertMsg,
  HOME_ROUTE,
  INT_CASINO_ROUTE,
} from "@hypexone/uicore";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import GCImage from "../../assets/images/Casino_svg_img/GC_Logo.svg";
import LICImage from "../../assets/images/Casino_svg_img/LIC.svg";
import { commonPaddingBottomForMobile } from "../../utils/constants/common.constants";
import Popup from "../components/home/Popup";
import HomeBannerCarousel from "../components/home/HomeBannerCarousel";
import MobileFooter from "../components/mobile-footer/MobileFooter";
import NewsAndPromotions from "../components/shared/NewsAndPromotions";
import Header from "../components/header/Header";
import LiveGif from "../../assets/images/Casino_svg_img/Live.svg";
import ProvidersSection from "./ProvidersSection";
import { isDesktop, isIOS, isMobile } from "react-device-detect";
import { appNavigationConstants } from "../../utils/constants/header.constants";
import { connect } from "react-redux";
import {
  BannerObjData,
  BannerResData,
} from "@hypexone/uicore/lib/cjs/src/models/Banners";
import HomeGames from "./WithdrawAmount/HomeGames";
import { SVLS_API_CLIENT } from "../../App.utils";
import { BRAND_DOMAIN, domain } from "../../constants/Branding";
import { AxiosResponse } from "axios";
import ClientSecurityMessageModal from "../components/header/ClientSecurityMessageModal";
import YuviGames from "../components/YuviGames/YuviGames";
import CustomerSupportIcon from "../../assets/icons/customer-support.svg?react";
import { FaWhatsapp } from "react-icons/fa6";
import Lottie from "lottie-react";

import { MdOutlineCancel } from "react-icons/md";
import { getEnvVariable } from "../../constants/brandConfig";
import Modal from "../components/shared/ModalComponent";
import Button from "../components/shared/Button/Button";
import { trackApkDownload } from "../../utils/trackApkDownload";
import OldApkbanner from "../../assets/images/old_users_apk.jpeg";
import "./apkCopyLink.css";
import { useWhatsappLink } from "../../utils/hooks/useWhatsappLink.hooks";
import { isApkCopyLinkDomain } from "../../constants/apkCopyLink";
import { useDownloadAppBannerClick, visibleBanners } from "../../utils/apkBanner";

export const isAndroidWebView = (): boolean => {
    if (typeof navigator === "undefined") return false;
    const ua = navigator.userAgent || "";
    const isAndroid = /Android/i.test(ua);
    const hasWvToken = /; wv\)/i.test(ua);
    const isChromeBrowser = /Chrome\/[\d.]+/i.test(ua) && !/EdgA\//i.test(ua);
    const looksLikeStandaloneChrome =
      isChromeBrowser && /Version\/[\d.]+/i.test(ua) === false && !hasWvToken;
    return (
      isAndroid &&
      (hasWvToken || (!looksLikeStandaloneChrome && /Version\/[\d.]+/i.test(ua)))
    );
  };

const FANTASY_SPORTS_SECTION_CODE = "fantasy_sports";
const CASINO_LOBBY_SECTION_CODE = "casino_lobby";
const SKY_GIFS_SECTION_CODE = "sky_gifs";
const HOME_SECTION_CODES = [
  CasinoTagsEnum.NEW_LAUNCH + "_sky",
  CasinoTagsEnum.TRENDING,
  CasinoTagsEnum.RECOMMENDED_GAMES,
  CasinoTagsEnum.LIVE_CASINO_GAMES,
  CasinoTagsEnum.SLOTS,
  CASINO_LOBBY_SECTION_CODE,
  FANTASY_SPORTS_SECTION_CODE,
  SKY_GIFS_SECTION_CODE,
];

const HomeFantasySports = ({
  onGameClick,
}: {
  onGameClick: (game: SectionGame) => void;
}) => {
  const { games: fantasySportsGames, lottieAnimations } = useHomeSectionGames(
    SVLS_API_CLIENT,
    FANTASY_SPORTS_SECTION_CODE
  );

  const count = fantasySportsGames.length;

  if (count === 0) {
    return null;
  }

  // 4 items → 2x2; otherwise all items side-by-side (desktop + mobile)
  const isTwoByTwo = count === 4;

  return (
    <div
      className={
        isTwoByTwo
          ? "grid grid-cols-2 gap-[2px] w-full"
          : "grid gap-[2px] w-full"
      }
      style={
        isTwoByTwo
          ? undefined
          : { gridTemplateColumns: `repeat(${count}, minmax(0, 1fr))` }
      }
    >
      {fantasySportsGames.map((game) => {
        const imageUrl = getSectionGameImage(game);
        const gameKey = getSectionGameKey(game);
        const lottieData = lottieAnimations[gameKey];

        return (
          <div
            key={gameKey}
            className="w-full cursor-pointer min-w-0"
            onClick={() => onGameClick(game)}
          >
            {isSectionLottieFile(imageUrl) && lottieData ? (
              <Lottie animationData={lottieData} loop={true} />
            ) : (
              imageUrl && (
                <img
                  src={imageUrl}
                  alt={getSectionGameLabel(game)}
                  className="w-full h-auto object-cover"
                />
              )
            )}
          </div>
        );
      })}
    </div>
  );
};


const HomePage = ({ loggedIn, balance, exposure }) => {
  const navigate = useNavigate();
  const handleDownloadAppBanner = useDownloadAppBannerClick();
  const dispatch = useAppDispatch();
  const { langData } = useAppSelector((state) => state.cms);
  const { domainConfig } = useAppSelector((state) => state.common);
  const { whatsappLink } = useWhatsappLink();
  const allowedTrendingNames = [
    "coin flip",
    "fortune wheel",
    "twistx",
    "lucky 5",
    "rock paper scissors",
    "valentine",
    "bolly kiss",
    "limbo",
    "plinko",
    "crash x",
    "diamonds",
    "pushpa rani",
    "dice",
  ];
  // const { loggedIn } = useAppSelector((state) => state.auth);
  const [showLoginPopup, setShowLoginPopup] = useState(false);

  const handleSectionGameClick = (game: SectionGame) => {
    const path = getSectionGameNavigationPath(
      game,
      INT_CASINO_ROUTE,
      "subProvider"
    );
    if (!path) return;

    if (isProviderCategorySectionEntry(game)) {
      navigate(path);
      return;
    }

    if (!loggedIn) {
      setShowLoginPopup(true);
      return;
    }

    const loggedInUserStatus = JSON.parse(
      window.atob(sessionStorage.getItem("jwt_token").split(".")[1])
    ).status;
    if (loggedInUserStatus === 0 || loggedInUserStatus === 3) {
      navigate(HOME_ROUTE);
      return;
    }

    if (game.providerName === "Indian Casino") {
      navigate(`/casino/indian/${game.gameCode}`);
      return;
    }

    navigate(path, { state: { gameName: game.gameName } });
  };

  // Before and After Login Banners
  const [popupBanner, setPopupBanner] = useState<BannerObjData>();
  const [downloadApkBanner, setDownloadApkBanner] = useState<BannerObjData>();
  const [popupMobileBanner, setPopupMobileBanner] = useState<BannerObjData>();
  const [downloadApkMobileBanner, setDownloadApkMobileBanner] =
    useState<BannerObjData>();
  const [showApkPopup, setShowApkPopup] = useState(false);
  const [isApkAvailable, setIsApkAvailable] = useState<boolean>(false);
  const [showPopup, setShowPopup] = useState(false);
  const [showWhatsapp, setShowWhatsapp] = useState<boolean>(true);

  const apkUrl = getEnvVariable(domain, "apk_url") || domainConfig?.apkUrl;

  useEffect(() => {
    if (loggedIn) {
      dispatch(fetchNotifications());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loggedIn]);

  function handleNavigation(url: string) {
    // Check if the user is trying to navigate to /sportsbook and if they are logged in
    if (url === "/sportsbook" && !loggedIn) {
      setShowLoginPopup(true); // Show the popup if not logged in
      return; // Stop the navigation
    }
    navigate(url); // Navigate if allowed
  }

  const { events: catalogEvents, selectedEventType } = useAppSelector(
    (state) => state.catalog,
  );
  const { allowedConfig } = useAppSelector((state) => state.common);

  const inplayEvents = getInplayEvents(catalogEvents, allowedConfig);

  // Create a combined array of all sports with their event counts
  const allSportsWithCounts = EXCHANGE_EVENT_TYPES.map((sport) => {
    const inplayEvent = inplayEvents.find(
      (event) => event?.sportName?.toLowerCase() === sport?.name?.toLowerCase(),
    );
    return {
      ...sport,
      eventCount: inplayEvent ? inplayEvent.events.length : 0,
      sportName: sport.name,
    };
  });

  useEffect(() => {
    dispatch(fetchInplayEvent());
  }, []);

  const getPopupBanners = async () => {
    const bannersRes: AxiosResponse<BannerResData> = await SVLS_API_CLIENT.get(
      `/account/v2/books/${BRAND_DOMAIN}/banners`,
      {
        params: {
          category: "popupbanner,downloadApkBanner",
          status: "active",
        },
      },
    );

    if (bannersRes.data.banners && bannersRes.data.banners.length >= 2) {
      setDownloadApkBanner(
        visibleBanners(bannersRes.data.banners, isAndroidWebView()).filter(
          (b) => b.category == "downloadApkBanner" && b.deviceType == "desktop",
        )[0],
      );
      setDownloadApkMobileBanner(
        visibleBanners(bannersRes.data.banners, isAndroidWebView()).filter(
          (b) => b.category == "downloadApkBanner" && b.deviceType == "mobile",
        )[0],
      );

      setPopupBanner(
        visibleBanners(bannersRes.data.banners, isAndroidWebView()).filter(
          (b) => b.category == "popupbanner" && b.deviceType == "desktop",
        )[0],
      );
      setPopupMobileBanner(
        visibleBanners(bannersRes.data.banners, isAndroidWebView()).filter(
          (b) => b.category == "popupbanner" && b.deviceType == "mobile",
        )[0],
      );
    }
  };

  useEffect(() => {
    if (!sessionStorage.getItem("popup_shown")) {
      getPopupBanners();
    }
  }, []);

  const closePopup = () => {
    sessionStorage.setItem("popup_shown", "true");
    setShowPopup(false);
  };

  const handleBannerRedirect = (redirectionUrl?: string) => {
    const redirectUrl = redirectionUrl?.trim();
    if (!redirectUrl || redirectUrl.toLowerCase() === "nourl") {
      return;
    }

    if (redirectUrl.startsWith("http")) {
      window.location.href = redirectUrl;
      return;
    }

    navigate(redirectUrl.startsWith("/") ? redirectUrl : `/${redirectUrl}`);
  };

  const handlePopupBannerClick = () => {
    const banner = isMobile ? popupMobileBanner : popupBanner;
    if (handleDownloadAppBanner(banner, "popup_banner")) {
      closePopup();
      return;
    }

    const redirectUrl = banner?.redirectionUrl;
    closePopup();
    handleBannerRedirect(redirectUrl);
  };

  useEffect(() => {
    if (loggedIn && !sessionStorage.getItem("popup_shown")) {
      setShowPopup(true);
    }
  }, [loggedIn]);

  useEffect(() => {
    if (!sessionStorage.getItem("apk_popup_shown")) {
      setShowApkPopup(true);
    }
  }, []);

  const closeApkPopup = () => {
    sessionStorage.setItem("apk_popup_shown", "true");
    setShowApkPopup(false);
  };

  useEffect(() => {
    setIsApkAvailable(!!apkUrl);
  }, [apkUrl]);

  // Domains where Android WebView users should copy APK link instead of direct download
  const shouldCopyApkLink = isApkCopyLinkDomain();

  

  const resolveApkHref = () => {
    if (!apkUrl) return null;
    return apkUrl.startsWith("http") ? apkUrl : `https://${apkUrl}`;
  };

  const copyApkLink = async () => {
    const url = resolveApkHref();
    if (!url) return;
    try {
      await navigator.clipboard.writeText(url);
    } catch {
      window.prompt("Copy this APK link:", url);
    }
    dispatch(
      setAlertMsg({
        type: "success",
        message: "Link copied. Open browser and paste to download the new APK.",
      })
    );
  };

  const downloadApp = async () => {
    if (!apkUrl) return;
    const url = resolveApkHref();
    if (!url) return;
    if (shouldCopyApkLink && isAndroidWebView()) {
      await copyApkLink();
      return;
    }
    trackApkDownload("popup");
    const link = document.createElement("a");
    link.href = url;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="flex bg-[#dee2e6] flex-col h-full w-full overflow-auto gap-[1px] mb-64 router-ctn">
      <div>
        <Header balance={balance} exposure={exposure} loggedIn={loggedIn} />
      </div>
      <div
        className={`w-full md:max-w-[76%] flex flex-col flex-1 m-auto overflow-auto hide-scrollbar bg-white pb-32 ${commonPaddingBottomForMobile}`}
      >
        <div className="flex flex-col gap-[2px]">
          <div className="hidden md:block">
            <NewsAndPromotions />
          </div>
          <HomeBannerCarousel />
          <HomeSectionGamesProvider
            apiClient={SVLS_API_CLIENT}
            sectionCodes={HOME_SECTION_CODES}
          >
          <HomeFantasySports onGameClick={handleSectionGameClick} />
          <div className="relative flex flex-col space-y-0.5">
            <div className="grid grid-cols-4 md:grid-cols-6 gap-0.5 w-full">
              {gamesImagesData.map(
                ({ imageSrc, url, alt, customClassName, title }, index) => {
                  let computedClass = "";

                  if (index === 0) {
                    // Full width on both mobile and desktop
                    computedClass = "col-span-4 md:col-span-6";
                  } else if (index === 1) {
                    isDesktop
                      ? (computedClass = "col-span-2 md:col-span-3")
                      : (computedClass = "col-span-4 md:col-span-6");
                  } else if (index === 2) {
                    isDesktop
                      ? (computedClass = "col-span-2 md:col-span-3")
                      : (computedClass = "col-span-4 md:col-span-6");
                  } else {
                    // Two items per row
                    computedClass = "col-span-2 md:col-span-3";
                  }

                  return (
                    <div
                      key={index}
                      className={`w-full cursor-pointer relative ${computedClass}`}
                    >
                      <img
                        onClick={() => handleNavigation(url)}
                        src={imageSrc}
                        alt={alt}
                        className="w-full h-auto object-cover"
                      />

                      {index === 1 && (
                        <div className="absolute right-0 top-0 z-0 h-[calc(100%-32px)] bg-gradient-to-b from-black/95 to-black/30 w-[120px] md:w-[160px] text-white overflow-auto p-2">
                          <div className="w-16 h-5 overflow-hidden">
                            <img
                              className="object-cover h-4"
                              src={LiveGif}
                              alt="LiveGif"
                            />
                          </div>
                          <div className="flex flex-col gap-1">
                            {allSportsWithCounts.map(
                              (sport) =>
                                sport?.eventCount > 0 && (
                                  <div
                                    key={sport.id}
                                    className="text-[11px] leading-[10px] md:text-xs flex justify-between md:font-bold capitalize"
                                    onClick={() => {
                                      dispatch(
                                        setCompetition({
                                          id: "",
                                          name: "",
                                          slug: "",
                                        }),
                                      );
                                      dispatch(
                                        setEventType({
                                          id: sport.id,
                                          name: sport.name,
                                          slug: sport.slug,
                                        }),
                                      );
                                      navigate(
                                        `/exchange_sports/${sport.slug}`,
                                      );
                                    }}
                                  >
                                    <div>{sport.sportName}</div>
                                    <div className="bg-white text-black rounded-sm py-[2px] px-1 font-normal">
                                      {sport.eventCount}
                                    </div>
                                  </div>
                                ),
                            )}
                          </div>
                        </div>
                      )}

                      {title && (
                        // <div className="w-full bg-black text-center uppercase font-bold text-white p-1 px-2 text-xs md:text-sm">
                        //   {title}
                        // </div>
                        <div
                          className="flex w-full h-[32px] sm:h-[24px] flex-shrink-0 absolute bottom-0 left-0 right-0 border-b-4 border-goldenYellow"
                          onClick={() => handleNavigation(url)}
                        >
                          <div className="flex flex-1 items-center bg-gradient-to-r from-black to-transparent text-white pl-2 pr-1 py-1 text-[11px] font-bold cursor-pointer min-w-0">
                            <span className="truncate">{title}</span>
                          </div>
                          <button
                            type="button"
                            className="flex items-center justify-center flex-shrink-0 bg-goldenYellow text-black px-2 pl-4 py-1 text-[11px] font-bold cursor-pointer min-w-[70px] [clip-path:polygon(15%_0,100%_0,100%_100%,0_100%)] hover:opacity-90"
                          >
                            Play Now
                          </button>
                        </div>
                      )}
                    </div>
                  );
                },
              )}

              {showLoginPopup && (
                <Modal
                  isOpen={showLoginPopup}
                  onClose={() => setShowLoginPopup(false)}
                  title={langData?.["notice"]}
                >
                  <p className="mb-4">
                    Access required for gameplay. Please log in to proceed.
                  </p>
                  <Button
                    className="rounded py-2 px-6 text-white bg-slate-800"
                    onClick={() => setShowLoginPopup(false)}
                  >
                    OK
                  </Button>
                </Modal>
              )}
            </div>
            <HomeGames
              isLoggedIn={loggedIn}
              showPopUp={() => setShowLoginPopup(true)}
            />
          </div>

          <div>
            <div className="w-full py-[6px] px-[5px] text-[13px] md:text-[16px] uppercase my-[2px] font-bold text-black bg-goldenYellow">
              {langData?.["top_providers"]}
            </div>

            <div>
              <ProvidersSection />
            </div>
          </div>
          </HomeSectionGamesProvider>

          <div className=" flex-col flex items-center sm:px-0  md:px-20 gap-3">
            <div className="flex flex-col md:flex-row w-full max-w-[670px] mx-auto rounded-lg border border-black2 overflow-hidden md:min-h-[140px]">
              <div className="flex justify-center items-center w-full md:w-auto md:border-r border-r-black2 px-2 py-1 md:py-0">
                <img
                  src={GCImage}
                  alt="gc-image"
                  className="w-[120px] h-auto md:w-[120px] object-contain"
                />
              </div>
              <div className="flex flex-col md:flex-row justify-center md:justify-start items-center gap-1 sm:gap-3 md:p-3 p-1 md:px-4 w-full">
                <img
                  src={LICImage}
                  alt="lic-image"
                  className="max-w-[100px] w-full h-auto object-contain"
                />
                <span className="text-[11px] text-center md:text-left leading-snug">
                  Laser is the trading name of Sports Target B.V., a company
                  incorporated and regulated in Curaçao under company number
                  148053 with its registered office at Fransche Bloemweg 4,
                  Willemstad, Curaçao.
                </span>
              </div>
            </div>

            {isDesktop && (
              <div className="hidden w-full md:flex flex-col gap-2 items-center md:px-12 lg:px-20">
                <div className="text-center text-xs text-gray5 px-4">
                  Our website works best in the newest and last prior version of
                  these browsers: Google Chrome. Firefox
                </div>
                <div className="h-[1px] w-[76%] bg-black2" />
              </div>
            )}
            {isDesktop && (
              <div className="grid grid-cols-10 md:flex justify-center w-full text-[13px] md:text-[11px] text-black3 md:text-black underline gap-3 text-center">
                <span className="col-span-4 cursor-pointer text-right">
                  Privacy Policy
                </span>
                <span className="col-span-4 cursor-pointer text-right">
                  Terms And Conditions
                </span>
                <span className="col-span-6 cursor-pointer text-left">
                  Rules And Regulations
                </span>

                <span className="col-span-4 cursor-pointer">About Us</span>
                <span className="col-span-4 cursor-pointer">
                  Responsible Gaming
                </span>
              </div>
            )}
            {/* <div className="self-center">
            <img
              src={MobileAppQRImage}
              alt="mobile-app-qr"
              className="w-[150px]"
            />
          </div> */}
          </div>
        </div>
      </div>

      {isMobile || isIOS ? <YuviGames /> : null}

      <div className="md:hidden">
        <MobileFooter />
      </div>

      <div>
        {showApkPopup &&
        isApkAvailable &&
        (shouldCopyApkLink ||
          (downloadApkBanner?.publicUrl &&
            downloadApkMobileBanner?.publicUrl)) ? (
          !isAndroidWebView() && (
          <ClientSecurityMessageModal
            isOpen={showApkPopup}
            onClose={closeApkPopup}
            isContentWidth
            hideCloseIcon
            modalBg="bg-transparent"
            showCloseIconInsideContent
            closeOutside
          >
            <div
              className={`popup-banner-wrapper${
                shouldCopyApkLink ? " popup-banner-wrapper--old-apk" : ""
              }`}
            >
              <a
                href={resolveApkHref() || "#"}
                onClick={(e) => {
                  e.preventDefault();
                  downloadApp();
                }}
              >
                <img
                  src={
                    shouldCopyApkLink
                      ? OldApkbanner
                      : isMobile
                        ? downloadApkMobileBanner?.publicUrl
                        : downloadApkBanner?.publicUrl
                  }
                  alt="Download APK"
                  className={isMobile ? "" : "max-h-[66vh]"}
                />
              </a>
              {shouldCopyApkLink && apkUrl ? (
                <div className="old-apk-link-bar">
                  <p className="old-apk-link-bar__label">Official APK link</p>
                  <div className="old-apk-link-bar__row">
                    <p
                      className="old-apk-link-bar__url"
                      title={resolveApkHref() || apkUrl}
                    >
                      {apkUrl}
                    </p>
                    <button
                      type="button"
                      className="old-apk-link-bar__copy"
                      onClick={copyApkLink}
                    >
                      Copy
                    </button>
                  </div>
                  <p className="old-apk-link-bar__hint">
                    Browser mein paste karke new APK download kardo
                  </p>
                </div>
              ) : null}
            </div>
          </ClientSecurityMessageModal>
          )
        ) : (
          showPopup &&
          popupBanner &&
          popupMobileBanner && (
            <ClientSecurityMessageModal
              modalBg="bg-transparent"
              isOpen={showPopup}
              onClose={closePopup}
              hideCloseIcon
              isContentWidth
              showCloseIconInsideContent
              closeOutside
            >
              <img
                src={
                  isMobile
                    ? popupMobileBanner?.publicUrl
                    : popupBanner?.publicUrl
                }
                onClick={handlePopupBannerClick}
                className={isMobile ? "" : "max-h-[66vh]"}
              />
            </ClientSecurityMessageModal>
          )
        )}
      </div>

      {whatsappLink && (
        <a
          href={whatsappLink}
          target="_blank"
          rel="noreferrer"
          className={`bottom-[70px] right-4 z-50 w-12 h-12 rounded-full bg-[#25D366] flex items-center justify-center shadow-lg hover:opacity-90 ${
            showWhatsapp ? "fixed" : "hidden"
          }`}
          aria-label="WhatsApp"
        >
          <MdOutlineCancel
            height={20}
            width={20}
            className="absolute -top-1 -right-1 bg-white rounded-full"
            onClick={() => setShowWhatsapp(false)}
          />
          <CustomerSupportIcon />
        </a>
      )}
    </div>
  );
};
const mapStateToProps = (state: RootState) => {
  return {
    balance: state.auth.balanceSummary.balance,
    exposure: state.auth.balanceSummary.exposure,
    loggedIn: state.auth.loggedIn,
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(HomePage);
